import { render, staticRenderFns } from "./RewardsHistoryTransactionCard.vue?vue&type=template&id=d22c8928"
import script from "./RewardsHistoryTransactionCard.vue?vue&type=script&lang=js"
export * from "./RewardsHistoryTransactionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports